import React, { useState } from 'react'

import './mall-sort-group.scss'
import { Group } from '@/model/types/goods'
import { $post } from '@/api'
import { useDynamicList, useRequest } from 'ahooks'
import { Expaned, Column } from '@/components/layout/layout'
import { errorCallBack, get } from '@/utils'
import { Spin } from 'antd'
import { mallSortGoodStore } from '../store'
import useBemClass from '@/utils/hooks/useBEMClass'
import { SortableContainer } from 'react-sortable-hoc'
import { useRef } from 'react'
import $msg from '@/utils/message'
import { MallSortSelectGoodGroupItem } from './mall-sort-group-item'
import { goodsShelfStore } from '../../../store/goods-shelf'
import classnames from 'classnames'

const SortGroupList = SortableContainer(
    (props: { groupArr: Group[]; onClick: (index: number) => void; secondGroupId: number }) => {
        const getCls = useBemClass('mall-sort-goods-group')

        return (
            <Expaned className={getCls('content')}>
                {goodsShelfStore.mallShelfConfig?.hot_sold && (
                    <div className={classnames(getCls('item'), getCls('item-disabled'))}>两日热卖</div>
                )}
                {props.groupArr.map((group, index) => (
                    <MallSortSelectGoodGroupItem
                        index={index}
                        key={group.id}
                        group={group}
                        disabled={group.is_default}
                        groupArr={props.groupArr}
                        groupIndex={index}
                        onClick={(val, index) => {
                            props.onClick(index)
                        }}
                        secondGroupId={props.secondGroupId}
                    />
                ))}
            </Expaned>
        )
    },
)

const MallSortGoodsGroup = () => {
    const getCls = useBemClass('mall-sort-goods-group')

    const { list: groupArr, resetList, replace, move } = useDynamicList<Group>([])
    const groupIds = useRef<(number | undefined)[]>([])
    const [secondGroupId] = useState<number>(0)

    const sortGroupReq = useRequest(
        () =>
            $post({
                url: '/mall/editmallgrouppriority',
                params: { group_ids: groupIds.current },
            }),
        {
            manual: true,
            onSuccess: () => {
                $msg('success', '分组排序成功')
                mallSortGoodStore.setGroupUpdate()
            },
            onError: errorCallBack,
        },
    )

    const { loading } = useRequest(
        () =>
            $post({
                url: '/mall/getmallgoodsgroup',
            }),
        {
            onSuccess: async (e: Group[]) => {
                groupIds.current = e.map(g => g.id)
                const addOpenStatus = e.map((item, index) => ({
                    ...item,
                    open: groupArr.length ? groupArr[index].open : false, // 缓存分组展开状态
                }))
                resetList(addOpenStatus)
                if (goodsShelfStore.mallShelfConfig?.independent_shelf_opened) {
                    mallSortGoodStore.setActiveId(e[1].id)
                    if (get(e[1], 'secondary_group[0].id')) mallSortGoodStore.setSecondId(e[1].secondary_group[0].id)
                } else {
                    mallSortGoodStore.setActiveId(e[0].id)
                    if (get(e[0], 'secondary_group[0].id')) mallSortGoodStore.setSecondId(e[0].secondary_group[0].id)
                }
            },
        },
    )

    return (
        <Column className={getCls()}>
            <Spin spinning={loading} className={loading ? getCls('spin') : ''}>
                <SortGroupList
                    secondGroupId={secondGroupId}
                    groupArr={groupArr}
                    onClick={index => {
                        replace(index, {
                            ...groupArr[index],
                            open: !groupArr[index].open,
                        })
                    }}
                    distance={20}
                    axis="y"
                    helperClass="paymode-sort-helper"
                    onSortEnd={({ oldIndex, newIndex }) => {
                        if (oldIndex === newIndex) return
                        move(oldIndex, newIndex)
                        ;[groupIds.current[oldIndex], groupIds.current[newIndex]] = [
                            groupIds.current[newIndex],
                            groupIds.current[oldIndex],
                        ]
                        sortGroupReq.run()
                    }}
                />
            </Spin>
        </Column>
    )
}

export default MallSortGoodsGroup
